import { EnumRecord } from "../models/enum.model";

interface ICmsModuleModel {
  value: number;
  description: string;
}

export enum UserRoles {
  AboutUs = "AboutUs",
  CmsSetting = "CmsSetting",
  ContactUs = "ContactUs",
  Gallery = "Gallery",
  Menu = "Menu",
  Slider = "Slider",
  ServiceDesk = "ServiceDesk",
  Notification = "Notification",
  Statement = "Statement",
  QuickAccess = "QuickAccess",
  RelatedLink = "RelatedLink",
  TextNews = "TextNews",
  ImageNews = "ImageNews",
  VideoNews = "VideoNews",
  UserManagement = "UserManagement",
  Province = "Province",
  Karzar = "Karzar",
  Admin = "Admin",
  NormalUser = "NormalUser",
}

export const UserRolesEnum: EnumRecord<UserRoles, ICmsModuleModel> = {
  [UserRoles.AboutUs]: {
    value: 1,
    description: "درباره ما",
  },

  [UserRoles.CmsSetting]: {
    value: 2,
    description: "تنظیمات",
  },

  [UserRoles.ContactUs]: {
    value: 3,
    description: "تماس با ما",
  },

  [UserRoles.Gallery]: {
    value: 4,
    description: "گالری",
  },

  [UserRoles.Menu]: {
    value: 5,
    description: "منو",
  },

  [UserRoles.Slider]: {
    value: 6,
    description: "اسلایدر",
  },

  [UserRoles.ServiceDesk]: {
    value: 7,
    description: "میز خدمت",
  },

  [UserRoles.Notification]: {
    value: 8,
    description: "اطلاعیه",
  },

  [UserRoles.Statement]: {
    value: 9,
    description: "بیانیه",
  },

  [UserRoles.QuickAccess]: {
    value: 10,
    description: "دسترسی سریع",
  },

  [UserRoles.RelatedLink]: {
    value: 11,
    description: "لینک مرتبط",
  },

  [UserRoles.TextNews]: {
    value: 12,
    description: "خبر متنی",
  },

  [UserRoles.ImageNews]: {
    value: 13,
    description: "خبر تصویری",
  },

  [UserRoles.VideoNews]: {
    value: 14,
    description: "خبر ویدئویی",
  },

  [UserRoles.UserManagement]: {
    value: 15,
    description: "مدیریت کاربران",
  },

  [UserRoles.Province]: {
    value: 16,
    description: "مدیریت استان",
  },

  [UserRoles.Karzar]: {
    value: 17,
    description: "مدیریت کارزار",
  },

  [UserRoles.Admin]: {
    value: 18,
    description: "Admin",
  },

  [UserRoles.NormalUser]: {
    value: 19,
    description: "کاربر معمولی",
  },
};

export type TUserRoleEnum =
  (typeof UserRolesEnum)[keyof typeof UserRolesEnum]["value"];
